import {useState} from "react";
import {IFornecedor} from "@models/fornecedores/fornecedor.ts";
import {Button, Grid, TextField} from "@mui/material";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {FornecedorPesquisa} from "@components/fornecedores/FornecedorPesquisa.tsx";
import {Save} from '@mui/icons-material'
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {DefaultEventProps} from "@models/DefaultProps.ts";
import {_OrcamentosEndpoints} from "@localization/siteMap/endpoints/_OrcamentosEndpoints.ts";
import {Dayjs} from "dayjs";
import {DefaultDatePicker} from "@shared/custom/DefaultDatePicker.tsx";
import {ISolicitacaoOrcamento} from "@models/solicitacoes/orcamento.ts";
import {useApi} from "@contexts/hooks/api/useApi.ts";

interface CreateCodigoRastreioComponentProps extends Pick<DefaultEventProps<ISolicitacaoOrcamento>, 'onCreate'> {
    idOrcamento: number,
}

export function CreateCodigoRastreioComponent(props: CreateCodigoRastreioComponentProps) {
    const {Get} = useApi()
    const {createAlertFromResponse} = useAlert()
    const {onCreate, idOrcamento} = props

    const [transportadora, setTransportadora] = useState<IFornecedor>();
    const [dataPrevisao, setDataPrevisao] = useState<Dayjs | undefined>();
    const [codigo, setCodigo] = useState("");


    const saveHandler = () => {
        Get(_OrcamentosEndpoints.CreateCodigoRastreio({
            idOrcamento,
            codigo,
            transportadoraId: transportadora?.id,
            dataPrevisaoEntrega: dataPrevisao
        })).then(x => {
            createAlertFromResponse(x)
            if (x.status == 'Success') {
                if (onCreate != null)
                    onCreate(x.items)
            }
        })
    }

    return (<DefaultContainer>
        <Grid>
            <TextField value={codigo} onChange={(e) => setCodigo(e.target.value)} label={'Código de rastreio'}/>
        </Grid>
        <Grid>
            <FornecedorPesquisa onItemSelected={setTransportadora}/>
        </Grid>
        <Grid>
            <DefaultDatePicker value={dataPrevisao} catchValue={setDataPrevisao}/>
        </Grid>
        <Grid container justifyContent={'space-between'}>
            <Grid/>
            <Button onClick={saveHandler} endIcon={<Save/>}>
                Salvar
            </Button>
        </Grid>

    </DefaultContainer>)
}